
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { StickyChilli_Responsive } from "../StickyChilli/game_responsive";


    export class StickyChilliLink_Responsive extends StickyChilli_Responsive {

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "StickyChilliLink") {
            super(multigameParams, initData, gameName);
        }

    }